import {FC} from 'react';
import './MarketingPageHead.less';

type MarketingPageHeadProps = {
    title: string;
    subtitle: string;
};

/**
 * Page title + descriptive subtitle for the standalone Marketing pages
 * (Campaigns, Referrers) now that the old tabbed Marketing page is split.
 */
const MarketingPageHead: FC<MarketingPageHeadProps> = ({title, subtitle}) => (
    <header className="marketing-page-head">
        <h1 className="marketing-page-head__title">{title}</h1>
        <p className="marketing-page-head__subtitle">{subtitle}</p>
    </header>
);

export default MarketingPageHead;
